import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ServiceHero } from '../components/ServiceHero';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, HeartIcon, AwardIcon, UsersIcon, StarIcon, QuoteIcon, MapPinIcon } from 'lucide-react';
const WORKERS = [{
  name: 'Sarah M.',
  role: 'RN',
  rating: 4.9,
  location: 'Toronto, ON',
  image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&auto=format&fit=crop'
}, {
  name: 'David C.',
  role: 'RPN',
  rating: 4.8,
  location: 'Vancouver, BC',
  image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&auto=format&fit=crop'
}, {
  name: 'Priya K.',
  role: 'PSW',
  rating: 4.9,
  location: 'Calgary, AB',
  image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&auto=format&fit=crop'
}, {
  name: 'Amara O.',
  role: 'RN',
  rating: 4.7,
  location: 'Ottawa, ON',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&auto=format&fit=crop'
}, {
  name: 'James L.',
  role: 'RPN',
  rating: 4.8,
  location: 'Mississauga, ON',
  image: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=400&auto=format&fit=crop'
}, {
  name: 'Maria G.',
  role: 'PSW',
  rating: 4.9,
  location: 'Edmonton, AB',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&auto=format&fit=crop'
}, {
  name: 'Michael R.',
  role: 'RN',
  rating: 4.8,
  location: 'Hamilton, ON',
  image: 'https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=400&auto=format&fit=crop'
}, {
  name: 'Jessica W.',
  role: 'RPN',
  rating: 4.7,
  location: 'Surrey, BC',
  image: 'https://images.unsplash.com/photo-1551076805-e1869033e561?w=400&auto=format&fit=crop'
}];
const TESTIMONIALS = [{
  quote: 'Care Nomad has transformed how we handle staffing shortages. We went from scrambling for days to filling shifts in minutes. The quality of workers is consistently excellent.',
  author: 'Linda T.',
  role: 'Director of Care',
  facility: 'Sunrise LTC, Toronto',
  initials: 'LT'
}, {
  quote: 'For the first time in my career, I feel valued. I choose my shifts, I get paid fairly, and I know the facilities I work at actually want me there.',
  author: 'Marcus J.',
  role: 'RPN',
  facility: 'Care Nomad Worker, Vancouver',
  initials: 'MJ'
}, {
  quote: "The nurse-led vetting process gives us confidence that every worker who walks through our doors meets our clinical standards. It's a game-changer.",
  author: 'Dr. Patricia H.',
  role: 'Medical Director',
  facility: 'Maple Grove Health Centre, Calgary',
  initials: 'PH'
}];
export function WhyUs() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2448" data-mp="1k12rid7j1pxj">
      <Navbar data-id="element-2449" data-mp="1relhcn9fr935" />

      <main className="flex-1" data-id="element-2450" data-mp="1rf3ls7694tm5">
        {/* 1. Hero Section */}
        <ServiceHero badge="Nurse-Owned & Operated" title="Why Choose Care Nomad?" subtitle="Canada's first nurse-led healthcare staffing marketplace — built by healthcare professionals who understand your challenges." imageUrl="https://images.unsplash.com/photo-1582750433449-648ed127bb54?w=1600&auto=format&fit=crop" data-id="element-2451" data-mp="1wcmwix3qqo9c" />

        {/* 2. Value Propositions */}
        <section className="py-20 lg:py-28 bg-white" data-id="element-2452" data-mp="2fb7kwhe8zfja">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2453" data-mp="2f9o5et0f18ik">
            <div className="text-center mb-16" data-id="element-2454" data-mp="2k3sdxgpbxolr">
              <h2 className="text-3xl sm:text-4xl font-extrabold text-text-dark tracking-tight" data-id="element-2455" data-mp="2p1kh56vfcx59">
                What Sets Us Apart
              </h2>
              <div className="w-24 h-1.5 bg-accent-teal mx-auto mt-6 rounded-full" data-id="element-2456" data-mp="2t4grybeq3oyn" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-2457" data-mp="2y30h0kom5gv8">
              <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100 hover:shadow-float transition-shadow duration-300" data-id="element-2458" data-mp="2keqah2zung46">
                <div className="w-14 h-14 bg-soft-teal rounded-full flex items-center justify-center mb-6" data-id="element-2459" data-mp="2gdo9ohqaaw03">
                  <ShieldCheckIcon className="w-7 h-7 text-accent-teal" data-id="element-2460" data-mp="2u7fkrujnynxx" />
                </div>
                <h3 className="text-xl font-bold text-text-dark mb-3" data-id="element-2461" data-mp="2p70711vgzeff">
                  Nurse-Vetted Quality
                </h3>
                <p className="text-text-muted leading-relaxed" data-id="element-2462" data-mp="1xf2ax9i8pgzc">
                  Every worker is screened by a registered nurse, not HR
                  generalists. Credentials verified, references checked, and
                  clinical competency assessed before they ever take a shift.
                </p>
              </div>

              <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100 hover:shadow-float transition-shadow duration-300" data-id="element-2463" data-mp="3msxl8n2tgxlk">
                <div className="w-14 h-14 bg-soft-teal rounded-full flex items-center justify-center mb-6" data-id="element-2464" data-mp="3hunqueox2110">
                  <HeartIcon className="w-7 h-7 text-accent-teal" data-id="element-2465" data-mp="13p92dyupqqml" />
                </div>
                <h3 className="text-xl font-bold text-text-dark mb-3" data-id="element-2466" data-mp="18niycbo9hv99">
                  Worker-First Philosophy
                </h3>
                <p className="text-text-muted leading-relaxed" data-id="element-2467" data-mp="zl9mnih9bvua">
                  Healthcare workers choose their shifts, set their rates, and
                  keep more of their earnings. Better pay equals better
                  retention, which ultimately leads to better patient outcomes.
                </p>
              </div>

              <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100 hover:shadow-float transition-shadow duration-300" data-id="element-2468" data-mp="1dk9dmws8smtm">
                <div className="w-14 h-14 bg-soft-teal rounded-full flex items-center justify-center mb-6" data-id="element-2469" data-mp="1iiatl8udg60v">
                  <AwardIcon className="w-7 h-7 text-accent-teal" data-id="element-2470" data-mp="268559n2yfojj" />
                </div>
                <h3 className="text-xl font-bold text-text-dark mb-3" data-id="element-2471" data-mp="2b2swhtpcex1t">
                  Regulated & Compliant
                </h3>
                <p className="text-text-muted leading-relaxed" data-id="element-2472" data-mp="2fxvan6djlurq">
                  Fully compliant with Ontario LTCHA, BC CCALA, and federal
                  healthcare regulations. All workers carry valid provincial
                  registration and comprehensive liability insurance.
                </p>
              </div>

              <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100 hover:shadow-float transition-shadow duration-300" data-id="element-2473" data-mp="21yvxovze74be">
                <div className="w-14 h-14 bg-soft-teal rounded-full flex items-center justify-center mb-6" data-id="element-2474" data-mp="1x5t2ykivpotm">
                  <UsersIcon className="w-7 h-7 text-accent-teal" data-id="element-2475" data-mp="1s5wy6j2cxtd0" />
                </div>
                <h3 className="text-xl font-bold text-text-dark mb-3" data-id="element-2476" data-mp="1narb3gx7y8nc">
                  Community-Driven
                </h3>
                <p className="text-text-muted leading-relaxed" data-id="element-2477" data-mp="1e88bd5oqcc5b">
                  We believe in giving back to the profession that built us. A
                  portion of every transaction funds nursing scholarships and
                  essential mental health support for healthcare workers.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 3. Stats Bar */}
        <section className="bg-medical-blue py-16" data-id="element-2478" data-mp="7pqfszjgsm7d">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2479" data-mp="7p79yh739o9p">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center divide-x-0 lg:divide-x lg:divide-white/20" data-id="element-2480" data-mp="368nlv34c71h8">
              <div className="px-4" data-id="element-2481" data-mp="3b78lp1fofj55">
                <div className="text-4xl sm:text-5xl font-extrabold text-white mb-2" data-id="element-2482" data-mp="3g5sad9lnn917">
                  2,400+
                </div>
                <div className="text-soft-teal font-medium text-sm uppercase tracking-wider" data-id="element-2483" data-mp="3kws4y87axf0j">
                  Verified Workers
                </div>
              </div>
              <div className="px-4" data-id="element-2484" data-mp="2sg7nifmdrrmn">
                <div className="text-4xl sm:text-5xl font-extrabold text-white mb-2" data-id="element-2485" data-mp="2sf649nv7nytu">
                  98%
                </div>
                <div className="text-soft-teal font-medium text-sm uppercase tracking-wider" data-id="element-2486" data-mp="1lt59w1312y24">
                  Fill Rate
                </div>
              </div>
              <div className="px-4" data-id="element-2487" data-mp="1uump7h8m2vpr">
                <div className="text-4xl sm:text-5xl font-extrabold text-white mb-2" data-id="element-2488" data-mp="1urgzq0w2lrti">
                  4 min
                </div>
                <div className="text-soft-teal font-medium text-sm uppercase tracking-wider" data-id="element-2489" data-mp="24rhow3gmf25m">
                  Avg Match Time
                </div>
              </div>
              <div className="px-4" data-id="element-2490" data-mp="1zqk7vu7cke5p">
                <div className="text-4xl sm:text-5xl font-extrabold text-white mb-2" data-id="element-2491" data-mp="2dkkxnygbmqtx">
                  40%
                </div>
                <div className="text-soft-teal font-medium text-sm uppercase tracking-wider" data-id="element-2492" data-mp="29jr9d3yyva0i">
                  Cost Savings
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. Worker Gallery */}
        <section className="py-20 lg:py-28 bg-soft-teal" data-id="element-2493" data-mp="324y0vfq5plum">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2494" data-mp="325h7i0acwntc">
            <div className="text-center mb-16" data-id="element-2495" data-mp="374anq0h12sx7">
              <h2 className="text-3xl sm:text-4xl font-extrabold text-text-dark tracking-tight mb-4" data-id="element-2496" data-mp="371y7psutysms">
                Meet Our Care Professionals
              </h2>
              <p className="text-lg text-text-muted max-w-2xl mx-auto" data-id="element-2497" data-mp="2x4tghem4o6z4">
                Every member of our team is nurse-vetted, credential-verified,
                and passionate about patient care.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-2498" data-mp="2o79e22cj44mx">
              {WORKERS.map((worker, index) => <div key={index} className="bg-white rounded-2xl shadow-card overflow-hidden group hover:shadow-float transition-all duration-300" data-id="element-2499" data-mp="2eek8fo3ntkzi" data-mpi={index}>
                  <div className="aspect-square overflow-hidden relative" data-id="element-2500" data-mp="24hfkpju61hgl">
                    <img src={worker.image} alt={worker.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-2501" data-mp="t7cdpt9ydlc5" />
                    <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2.5 py-1 rounded-full text-xs font-bold text-medical-blue shadow-sm" data-id="element-2502" data-mp="k7pjbrfn5fsl">
                      {worker.role}
                    </div>
                  </div>
                  <div className="p-5" data-id="element-2503" data-mp="1gwng1f6ybnse">
                    <div className="flex items-center justify-between mb-1" data-id="element-2504" data-mp="1gvlu2foedgvw">
                      <h3 className="font-bold text-text-dark text-lg" data-id="element-2505" data-mp="135s5zzkpv0n8">
                        {worker.name}
                      </h3>
                      <div className="flex items-center gap-1 bg-gray-50 px-2 py-0.5 rounded-md" data-id="element-2506" data-mp="175arawgg9dql">
                        <StarIcon className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-2507" data-mp="1uuvbfiocah1g" />
                        <span className="text-xs font-bold text-text-dark" data-id="element-2508" data-mp="1zny5rt0xxuip">
                          {worker.rating}
                        </span>
                      </div>
                    </div>
                    <div className="flex items-center gap-1.5 text-sm text-text-muted mt-2" data-id="element-2509" data-mp="3fdp7ueoji7au">
                      <MapPinIcon className="w-4 h-4 text-accent-teal" data-id="element-2510" data-mp="3u21z4ycon1z0" />
                      {worker.location}
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* 5. Testimonials */}
        <section className="py-20 lg:py-28 bg-white" data-id="element-2511" data-mp="2wgee19log62s">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2512" data-mp="2whz7evw99iz2">
            <div className="text-center mb-16" data-id="element-2513" data-mp="3begidm0j8vl3">
              <h2 className="text-3xl sm:text-4xl font-extrabold text-text-dark tracking-tight" data-id="element-2514" data-mp="36e28dyfdfbkf">
                Trusted by Facilities & Workers Across Canada
              </h2>
              <div className="w-24 h-1.5 bg-accent-teal mx-auto mt-6 rounded-full" data-id="element-2515" data-mp="qor172ccwxp8" />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2516" data-mp="lpwale85e4uk">
              {TESTIMONIALS.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl shadow-card border border-gray-100 p-8 flex flex-col h-full hover:shadow-float transition-shadow duration-300" data-id="element-2517" data-mp="xpbfk1fu3gk4" data-mpi={index}>
                  <QuoteIcon className="w-10 h-10 text-accent-teal/20 mb-6" data-id="element-2518" data-mp="17mpmnafvaszr" />
                  <p className="text-text-dark italic leading-relaxed flex-1 mb-8 text-lg" data-id="element-2519" data-mp="a11p2m7oe4mn">
                    "{testimonial.quote}"
                  </p>
                  <div className="border-t border-gray-100 pt-6 flex items-center gap-4" data-id="element-2520" data-mp="ex0iio7v2ctx">
                    <div className="w-12 h-12 rounded-full bg-soft-teal flex items-center justify-center text-medical-blue font-bold text-lg flex-shrink-0" data-id="element-2521" data-mp="jwd3f3f699tv">
                      {testimonial.initials}
                    </div>
                    <div data-id="element-2522" data-mp="3sdzsj33offlk">
                      <div className="font-bold text-text-dark" data-id="element-2523" data-mp="3sd7wjr663fur">
                        {testimonial.author}
                      </div>
                      <div className="text-sm text-accent-teal font-medium" data-id="element-2524" data-mp="29ic1ggxc01r9">
                        {testimonial.role}
                      </div>
                      <div className="text-xs text-text-muted mt-0.5" data-id="element-2525" data-mp="20hxdtawwaakl">
                        {testimonial.facility}
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* 6. CTA Section */}
        <section className="bg-medical-blue py-20" data-id="element-2526" data-mp="1lshswbk1ozct">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2527" data-mp="1lrptsqr8ojhs">
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-6" data-id="element-2528" data-mp="1hs7afzf2ggh2">
              Ready to Experience the Care Nomad Difference?
            </h2>
            <p className="text-xl text-white/90 mb-10" data-id="element-2529" data-mp="17sgfxxqia1gz">
              Join thousands of facilities and healthcare workers across Canada.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-2530" data-mp="32wxyesgpkjw9">
              <Link to="/contact" className="w-full sm:w-auto px-8 py-4 bg-white text-medical-blue font-bold rounded-xl hover:bg-gray-50 transition-colors shadow-lg" data-id="element-2531" data-mp="32zagr6qdow9u">
                Get Care Now
              </Link>
              <Link to="/contact" className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-xl hover:bg-white/10 transition-colors" data-id="element-2532" data-mp="2y4mz9rtsl24r">
                Join as a Worker
              </Link>
            </div>
          </div>
        </section>
      </main>

      <StickyFooter data-id="element-2533" data-mp="2f7dgmcwajsok" />
    </div>;
}